import { Component, Input, OnInit } from '@angular/core';
import { ScaffoldDialogRef } from '@app/framework/dialog/scaffold-dialog.service';
import { IntegrationService } from '@services/integration.service';
import { tap } from 'rxjs/operators';
import { UserService } from '@services/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { EnvironmentService } from '@services/environment.service';
import { NotificationsService } from '@services/notifications.service';

@Component({
  selector: 'app-integration-status-modal',
  templateUrl: './integration-status-modal.component.html',
  styleUrls: ['./integration-status-modal.component.scss'],
  standalone: false,
})
export class IntegrationStatusModalComponent implements OnInit {
  @Input()
  set integration(value: any) {
    this._integration = value;
    this.logo = this.getLogo(value);
  }
  get integration(): any {
    return this._integration;
  }
  private _integration: any;
  logo: string;
  public integrations$;
  public statusItem;
  roleData: any;
  constructor(
    private dialogRef: ScaffoldDialogRef,
    private integrationService: IntegrationService,
    private userService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private environmentService: EnvironmentService,
    private notifications: NotificationsService
  ) {}

  ngOnInit(): void {
    this.userService.getRoleDetails().subscribe(data => {
      this.roleData = data;
    });
    this.integrations$ = this.integrationService
      .getIntegration$(this?.['data']?.integration?.id)
      .pipe(
        tap((integration: any) => {
          // if (state?.isLoading) return;
          if (!integration) {
            this.dialogRef.close();
            return;
          }
          this.integration = integration;
          if (this.integration.integration_type === 'live_event') {
            this.statusItem = this.getLiveEventStatus();
          } else {
            this.statusItem = this.integrationService.getStatusRequirements(
              this.integration
            );
          }
        })
      );
  }

  getLiveEventStatus() {
    return [
      {
        check: () => {
          return this.integrationService.checkCanvasDataServiceEnabled(
            this.integration.json_data.original_integration_id
          );
        },
        title: 'Canvas Data Service Enabled',
        messages: {
          ok: 'Canvas Data Service is enabled in the root account',
          error: 'Canvas Data Service is not enabled',
        },
      },
      {
        check: () => {
          return this.integration.json_data.State === 'Active';
        },
        title: 'Live Events Configured',
        messages: {
          ok: 'Live Events have been configured',
          error: 'Live Events have not been configured',
        },
      },
      {
        check: () => {
          return (
            this.integration.last_live_event_processed_date &&
            this.integration.last_live_event_processed_date !==
              'no events found'
          );
        },
        title: 'Live Events',
        messages: {
          ok:
            'Last event received ' +
            new Date(
              this.integration.last_live_event_processed_date
            ).toLocaleDateString(),
          error: 'No events received in the past 30 days',
        },
      },
    ];
  }

  getLogo(integration) {
    let type;
    if (integration.integration_type === 'dwh') {
      type = 'warehouse';
    } else if (integration.integration_type === 'live_event') {
      type = 'live_event';
    } else {
      type = integration.json_data[integration.integration_type + '_type'];
    }
    return `https://k16-hosted-lib.s3.us-east-2.amazonaws.com/${type}.png`;
  }

  getPlaceholderLogo() {
    return 'https://k16-hosted-lib.s3.us-east-2.amazonaws.com/placeholder.png';
  }

  validateStatus(): { status: string; title: string; message: string }[] {
    if (!Array.isArray(this.statusItem)) {
      return [];
    }
    if (this.integration.integration_type === 'live_event') {
      let results = this.statusItem.map(check => {
        check.status = check.check() ? 'ok' : 'error';
        check.message =
          check.status === 'ok' ? check.messages.ok : check.messages.error;
        return check;
      });
      return results;
    }
    return this.statusItem.map(status => {
      if (status.key) {
        let result;
        if (status.ifPresent) {
          result = this.integration?.json_data?.[status.key] || {
            status: 'ok',
            message: 'Check has not been run',
          };
        } else {
          result = this.integration?.json_data?.[status.key] || {
            status: 'error',
            message: 'Check has not been run',
          };
        }
        if (!result.message) {
          result.message = status.messages[result.status];
        }
        return { ...result, title: status.title };
      } else if (status.dataKeys) {
        let found = status.dataKeys.every(
          key => this.integration?.json_data?.[key]
        );
        let state = found ? 'ok' : 'error';
        return {
          status: state,
          title: status.title,
          message: status.messages[state],
        };
      }
    });
  }
  handleEditClick($event) {
    if (this.roleData?.manage_integrations) {
      this.environmentService.getInstanceDetails().subscribe(environment => {
        if (
          environment.scaffoldType === 'archivev2' &&
          !environment.no_self_serve
        ) {
          this.router
            .navigate(['imports/edit-integration/' + $event.id])
            .then(() => {
              this.dialogRef.close();
            });
        } else {
          this.router
            .navigate(['admin/integrations/edit/' + $event.id])
            .then(() => {
              this.dialogRef.close();
            });
        }
      });
    }
  }
  close() {
    this.dialogRef.close();
  }
  handleRefreshClick() {
    this.integrationService
      .refreshIntegration$(this.integration)
      .subscribe(response => {
        let hasError =
          response.error || response.errorMessage || !response?.[0]?.id;

        if (hasError) {
          this.notifications.popNotification(
            '',
            'Error Refreshing Integration'
          );
        } else {
          this.notifications.popNotification(
            '',
            'Initiated Integration Refresh'
          );
        }
      });
  }
}
